<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    <v-row align="center" :no-gutters="block.noGutters">
      <v-col v-if="block.label" :cols="block.labelCols" :lg="block.labelColslg" class="text-h7 font-weight-medium">
        {{ block.label }}
      </v-col>
      <template v-for="itemBlock in block.itemComponents">
        <component :is="itemBlock.component" :key="itemBlock.uid" v-model="form[itemBlock.uid]" :block="itemBlock" />
      </template>
    </v-row>
  </v-col>
</template>

<script>
export default {
   name: 'Product',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },

   data () {
      return {
         show: false
      }
   },

   watch: {
      'form.show': function (val, oldVal) {
         this.$emit('update:form', this.form)
      },
      'form.optional': function (val, oldVal) {
         this.$emit('update:form', this.form)
      }
   }
}
</script>
